import { render, staticRenderFns } from "./LocationsTour.vue?vue&type=template&id=138a0cac&"
import script from "./LocationsTour.vue?vue&type=script&lang=js&"
export * from "./LocationsTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports